<div class="summary-row p-20 border-bottom" [class.d-flex]="hasLabel">
  <div class="label eyfontbold me-10" *ngIf="hasLabel">{{ label }}:</div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
